export type TokenId = number;
export enum TokenType {
    GROUP_COACHING = 'group_coaching',
    MOKUMOKU = 'mokumoku',
    EVENT = 'event',
    ONLINE_LESSON = 'online_lesson',
    MULTICREATOR = 'multicreator_course',
}
